// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wine-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(61, 24, 24, 0.85);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.wine-preview-modal {
  width: 750px;
  max-height: 95vh;
  position: relative;
  animation: slideUp 0.3s ease;
  overflow-y: auto;
  overflow-x: hidden;
  background: transparent;
}

@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.wine-preview-close {
  position: absolute;
  top: -15px;
  right: -15px;
  background: rgba(61, 24, 24, 0.95);
  color: #FAF6E7;
  border: none;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  font-size: 32px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(61, 24, 24, 0.4);
  border: 3px solid #E8D5B7;
}

.wine-preview-close:hover {
  background: #3D1818;
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(61, 24, 24, 0.5);
}

.wine-preview-close:active {
  transform: scale(0.95);
}

.wine-preview-frame {
  width: 750px;
  min-height: 1000px;
  background: #ffffff;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
}


.wine-preview-image {
  max-width: 750px;
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
  z-index: 1;
  position: relative;
}

/* Responsive - keep 1200x1600 but adjust overlay padding on smaller screens */
@media (max-width: 1400px) {
  .wine-preview-overlay {
    padding: 10px;
  }
}

@media (max-width: 768px) {
  .wine-preview-overlay {
    padding: 5px;
  }

  .wine-preview-close {
    top: -10px;
    right: -10px;
    width: 35px;
    height: 35px;
    font-size: 24px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/WinePreviewModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,kCAAkC;EAClC,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;;AAGA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,kBAAkB;AACpB;;AAEA,8EAA8E;AAC9E;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".wine-preview-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(61, 24, 24, 0.85);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  padding: 20px;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.wine-preview-modal {\n  width: 750px;\n  max-height: 95vh;\n  position: relative;\n  animation: slideUp 0.3s ease;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: transparent;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(30px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.wine-preview-close {\n  position: absolute;\n  top: -15px;\n  right: -15px;\n  background: rgba(61, 24, 24, 0.95);\n  color: #FAF6E7;\n  border: none;\n  width: 45px;\n  height: 45px;\n  border-radius: 50%;\n  font-size: 32px;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 16px rgba(61, 24, 24, 0.4);\n  border: 3px solid #E8D5B7;\n}\n\n.wine-preview-close:hover {\n  background: #3D1818;\n  transform: scale(1.1);\n  box-shadow: 0 6px 20px rgba(61, 24, 24, 0.5);\n}\n\n.wine-preview-close:active {\n  transform: scale(0.95);\n}\n\n.wine-preview-frame {\n  width: 750px;\n  min-height: 1000px;\n  background: #ffffff;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  box-sizing: border-box;\n}\n\n\n.wine-preview-image {\n  max-width: 750px;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n  display: block;\n  z-index: 1;\n  position: relative;\n}\n\n/* Responsive - keep 1200x1600 but adjust overlay padding on smaller screens */\n@media (max-width: 1400px) {\n  .wine-preview-overlay {\n    padding: 10px;\n  }\n}\n\n@media (max-width: 768px) {\n  .wine-preview-overlay {\n    padding: 5px;\n  }\n\n  .wine-preview-close {\n    top: -10px;\n    right: -10px;\n    width: 35px;\n    height: 35px;\n    font-size: 24px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
